// export default WeighingRecords;
import React, { useState, useEffect } from "react";
import {
  Calendar,
  MapPin,
  Download,
  Trash2,
  CheckCircle2,
  AlertCircle,
} from "lucide-react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx-js-style";

const WeighingRecords = () => {
  const [records, setRecords] = useState([]);

  // Filter states
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [site, setSite] = useState("");
  const [entryMethod, setEntryMethod] = useState("");
  const [validation, setValidation] = useState("");
  const [tag, setTag] = useState("");
  const [offset, setOffset] = useState(0);
  const userRole = localStorage.getItem("role");
  const userId = localStorage.getItem("id");
  const navigate = useNavigate();
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "asc",
  });
  const handleSort = (key) => {
    let direction = "asc";

    // Toggle direction if clicking same column again
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }

    setSortConfig({ key, direction });

    setRecords((prev) => {
      return [...prev].sort((a, b) => {
        if (!a[key]) return 1;
        if (!b[key]) return -1;

        // Numeric sorting
        if (!isNaN(a[key]) && !isNaN(b[key])) {
          return direction === "asc" ? a[key] - b[key] : b[key] - a[key];
        }

        // String sorting
        return direction === "asc"
          ? a[key].toString().localeCompare(b[key].toString())
          : b[key].toString().localeCompare(a[key].toString());
      });
    });
  };
  const SortArrow = ({ columnKey }) => {
    const isActive = sortConfig.key === columnKey;

    return (
      <span className="ml-1 inline-flex flex-col text-[8px] leading-none">
        {/* Up arrow */}
        <span
          className={
            isActive && sortConfig.direction === "asc"
              ? "text-slate-900"
              : "text-slate-300"
          }
        >
          ▲
        </span>

        {/* Down arrow */}
        <span
          className={
            isActive && sortConfig.direction === "desc"
              ? "text-slate-900"
              : "text-slate-300"
          }
        >
          ▼
        </span>
      </span>
    );
  };

  const fetchRecords = async () => {
    try {
      const params = new URLSearchParams();
      if (site) params.append("siteMac", site);
      if (dateFrom) params.append("dateFrom", dateFrom);
      if (dateTo) params.append("dateTo", dateTo);
      if (entryMethod) params.append("entryMethod", entryMethod);
      if (validation) params.append("mode", validation);
      if (tag) params.append("tag", tag);

      //params.append("limit", 1000);
      params.append("offset", offset);
      params.append("t", new Date());

      const res = await fetch(
        `https://db2sg.com/tagweigh/api/weighings?${params.toString()}`
      );
      const data = await res.json();
      //   let weighings = data.weighings || [];
      let weighings = (data.weighings || []).sort(
        (a, b) => Number(b.id) - Number(a.id) // newest first
      );

      if (userRole === "user") {
        weighings = weighings.filter(
          (w) => w.user?.toString() === userId?.toString()
        );
      }

      const formattedRecords = weighings.map((w) => ({
        id: w.id,
        site: w.name || w.site_mac,
        tag: w.tag_number || "",
        ear: w.ear_number || "",
        burn: w.burn_number || "",
        weight: w.weight,
        method: w.entry_method,
        validation:
          w.validated === 1 || w.validated === "1"
            ? "Verified"
            : w.validated === 0 || w.validated === "0"
            ? "Not Verified"
            : "Not Verified",
        date: w.weight_date,
        time: w.weight_time,
        status: w.mode,
        last_heartbeat: w.last_heartbeat || null,
      }));

      setRecords(formattedRecords);
    } catch (err) {
      console.error(err);
      alert("Failed to load weighings.");
    } finally {
    }
  };

  const formatJerusalemDateTime = (dateStr, timeStr) => {
    if (!dateStr || !timeStr) return "";

    // Combine UTC date + time
    const utcDate = new Date(`${dateStr}T${timeStr}Z`);

    return utcDate.toLocaleString("en-IL", {
      timeZone: "Asia/Jerusalem",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
  };
  const fetchRecordsWithFilters = async (type, data1, date) => {
    try {
      const params = new URLSearchParams();
      if (type === "validation") params.append("validated", data1);
      if (type === "mode") params.append("mode", data1);
      console.log(dateFrom);
      if (date) params.append("dateFrom", date);

      //params.append("limit", 100);
      params.append("offset", offset);
      params.append("t", new Date());

      const res = await fetch(
        `https://db2sg.com/tagweigh/api/weighings?${params.toString()}`
      );
      const data = await res.json();
      //  let weighings = data.weighings || [];
      let weighings = (data.weighings || []).sort(
        (a, b) => Number(b.id) - Number(a.id) // newest first
      );

      if (userRole === "user") {
        weighings = weighings.filter(
          (w) => w.user?.toString() === userId?.toString()
        );
      }

      const formattedRecords = weighings.map((w) => ({
        id: w.id,
        site: w.name || w.site_mac,
        tag: w.tag_number || "",
        ear: w.ear_number || "",
        burn: w.burn_number || "",
        weight: w.weight,
        method: w.entry_method,
        validation:
          w.validated === 1 || w.validated === "1"
            ? "Verified"
            : w.validated === 0 || w.validated === "0"
            ? "Not Verified"
            : "Not Verified",
        date: w.weight_date,
        time: w.weight_time,
        status: w.mode,
        last_heartbeat: w.last_heartbeat || null,
      }));

      setRecords(formattedRecords);
    } catch (err) {
      console.error(err);
      alert("Failed to load weighings.");
    } finally {
    }
  };
  const [sites, setSites] = useState([]);
  const fetchSites = async () => {
    try {
      const res = await fetch(
        `https://db2sg.com/tagweigh/api/sites?_t=${Date.now()}`
      );
      const data = await res.json();
      let filteredSites = data || [];

      // --- FILTER SITES DROPDOWN ---
      if (userRole === "user") {
        filteredSites = filteredSites.filter(
          (s) => s.user?.toString() === userId?.toString()
        );
        // Auto-select the site for the user
        if (filteredSites.length > 0) {
          setSite(filteredSites[0].mac);
        }
      }

      setSites(filteredSites);
      // setSites(data);
    } catch (e) {
      console.error("Failed to load sites", e);
    }
  };
  const location = useLocation();
  const navFilter = location.state?.filter; // validated | manual | skipped | auto

  useEffect(() => {
    if (!navFilter) {
      fetchRecords();
      return;
    }
    console.log(navFilter);

    switch (navFilter) {
      case "validated":
        setValidation("validated");
        if (location.state?.time === "today") {
          const date = new Date()?.toISOString()?.split("T")[0];
          fetchRecordsWithFilters("validation", "true", date);
        } else {
          fetchRecordsWithFilters("validation", "true", null);
        }
        break;

      case "manual":
        setValidation("manual");
        if (location.state?.time === "today") {
          const date = new Date()?.toISOString()?.split("T")[0];
          fetchRecordsWithFilters("mode", "manual", date);
        } else {
          fetchRecordsWithFilters("mode", "manual", null);
        }
        break;

      case "auto":
        setValidation("auto");
        if (location.state?.time === "today") {
          const date = new Date()?.toISOString()?.split("T")[0];
          fetchRecordsWithFilters("mode", "auto", date);
        } else {
          fetchRecordsWithFilters("mode", "auto", null);
        }
        break;

      case "skipped":
        setValidation("skipped");
        if (location.state?.time === "today") {
          const date = new Date()?.toISOString()?.split("T")[0];
          fetchRecordsWithFilters("mode", "skipped", date);
        } else {
          fetchRecordsWithFilters("mode", "skipped", null);
        }
        break;

      default:
        break;
    }
    // eslint-disable-next-line
  }, [navFilter]);

  useEffect(() => {
    fetchSites();
    // eslint-disable-next-line
  }, []);

  const handleFilter = (e) => {
    e.preventDefault();
    fetchRecords();
  };

  const handleClear = () => {
    setDateFrom("");
    setDateTo("");
    setSite("");
    setEntryMethod("");
    setValidation("");
    setTag("");
    setOffset(0);
    fetchRecords();
    navigate("/weighings", { replace: true });
  };
  // ✅ Format date depending on language
  const formatDate = (dateStr, isEnglish) => {
    if (!dateStr) return "";

    const d = new Date(dateStr);

    if (isEnglish) {
      // English → keep ISO style
      return d.toISOString().split("T")[0];
    } else {
      // Hebrew → MM/DD/YYYY
      return d.toLocaleDateString("en-US");
    }
  };

  // ✅ Format time → 9:10:00 AM
  const formatTime = (timeStr) => {
    if (!timeStr) return "";

    // Create fake Date object using today's date + time
    const dateObj = new Date(`1970-01-01T${timeStr}`);

    return dateObj.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  };

  const downloadCSV = () => {
    if (!records.length) {
      alert("אין נתונים לייצוא");
      return;
    }
    // ✅ Ask user for language
    const lang = window.prompt(
      "Choose CSV Language:\nType 'en' for English or 'he' for Hebrew",
      "he"
    );

    if (!lang) return;

    const isEnglish = lang.toLowerCase() === "en";
    const headers = isEnglish
      ? [
          "Tag (Chip)",
          "Government Number (Ear)",
          "Burn Number",
          "Weighing Date",
          "Weighing Time",
          "Weight",
          "Height",
          "Weighing Site Name",
        ]
      : [
          "ציפ",
          "מספר ממשלתי (אוזן)",
          "מספר כוויה",
          "תאריך שקילה",
          "שעת שקילה",
          "משקל",
          "גובה",
          "שם אתר השקילה",
        ];

    // CSV headers based on the current table display
    // const headers = [
    //   "ID",
    //   "Site",
    //   "Tag",
    //   "Weight",
    //   "Method",
    //   "Validation",
    //   "Date",
    //   "Time",
    //   "Status",
    // ].join(",");
    const rows = records.map((r) => [
      r.tag,
      r.ear,
      r.burn,
      //  r.date,
      formatDate(r.date, isEnglish),

      //  r.time,
      formatTime(r.time),

      r.weight,
      "",
      r.site,
    ]);

    // Combine header + rows
    const sheetData = [headers, ...rows];

    // Create worksheet
    const ws = XLSX.utils.aoa_to_sheet(sheetData);
    // ✅ Right-align all rows if Hebrew selected
    if (!isEnglish) {
      const range = XLSX.utils.decode_range(ws["!ref"]);

      for (let R = 1; R <= range.e.r; R++) {
        for (let C = 0; C <= range.e.c; C++) {
          const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });

          if (!ws[cellAddress]) continue;

          ws[cellAddress].s = {
            ...ws[cellAddress].s,
            alignment: {
              horizontal: "right",
              vertical: "center",
            },
          };
        }
      }
    }

    // ✅ Apply Blue Header Style
    headers.forEach((_, colIndex) => {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: colIndex });

      if (!ws[cellAddress]) return;

      ws[cellAddress].s = {
        fill: {
          fgColor: { rgb: "1E3A8A" }, // Blue
        },
        font: {
          bold: true,
          color: { rgb: "FFFFFF" }, // White text
          sz: 12,
        },
        alignment: {
          horizontal: "center",
        },
      };
    });

    // ✅ Auto Column Width Based on Header + Content
    ws["!cols"] = headers.map((header, i) => {
      const maxLength = Math.max(
        header.length,
        ...rows.map((row) => (row[i] ? row[i].toString().length : 0))
      );

      return {
        wch: maxLength + 4, // Padding
      };
    });

    // Create workbook
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Weighings");

    // Download
    XLSX.writeFile(
      wb,
      isEnglish
        ? `NOA_EXPORT_${Date.now()}.xlsx`
        : `NOA_EXPORT_${Date.now()}.xlsx`
    );
  };

  return (
    <div className="animate-in fade-in slide-in-from-bottom-8 duration-1000 pb-20 ltr">
      <div className="flex flex-col md:flex-row justify-between items-center mb-4 gap-4">
        <button
          onClick={downloadCSV}
          className="flex items-center gap-2 px-4 py-3 bg-slate-900 text-white font-black rounded-xl hover:bg-black transition-all shadow-lg shadow-slate-200 active:scale-95"
        >
          <Download size={20} />
          NOA REPORT{" "}
        </button>
      </div>
      <div className="bg-white rounded-[1rem] border border-slate-100 shadow-xl p-8 mb-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 mb-1 items-end">
          <FilterGroup label="מתאריך" icon={<Calendar size={14} />}>
            <input
              type="date"
              value={dateFrom}
              onChange={(e) => {
                console.log(e.target.value);
                setDateFrom(e.target.value);
              }}
              className="w-full bg-slate-50 border-none rounded-l p-2 font-bold text-slate-700 outline-none"
            />
          </FilterGroup>
          <FilterGroup label="עד תאריך" icon={<Calendar size={14} />}>
            <input
              type="date"
              value={dateTo}
              onChange={(e) => setDateTo(e.target.value)}
              className="w-full bg-slate-50 border-none rounded-l p-2 font-bold text-slate-700 outline-none"
            />
          </FilterGroup>
          <FilterGroup label="אתר" icon={<MapPin size={14} />}>
            <select
              value={site}
              onChange={(e) => setSite(e.target.value)}
              className="w-full bg-slate-50 border-none rounded-l p-2 font-bold text-slate-700 outline-none"
            >
              <option value="">כל האתרים</option>
              {sites.map((s) => (
                <option key={s.mac} value={s.mac}>
                  {s.name}
                </option>
              ))}
            </select>
          </FilterGroup>

          {/* <div className="flex gap-3 lg:col-span-2"> */}
          <FilterGroup label="" icon={<MapPin size={14} color={"#fff"} />}>
            <button
              onClick={handleFilter}
              className="w-full h-[39px] bg-slate-900 text-white rounded-l font-black uppercase hover:bg-slate-800 transition-all"
            >
              🔍 סנן
            </button>
          </FilterGroup>
          <FilterGroup label="" icon={<MapPin size={14} color={"#fff"} />}>
            <button
              onClick={handleClear}
              className="px-6 bg-slate-100 text-slate-500 p-2 rounded-l font-black uppercase tracking-widest hover:bg-slate-200 transition-all flex items-center gap-2"
            >
              <Trash2 size={18} />
              נקה
            </button>
          </FilterGroup>
          {/* </div> */}
        </div>
      </div>

      {/* Results Table */}
      <div className="bg-white rounded-[1rem] border border-slate-100 shadow-2xl overflow-hidden">
        <div className="px-7 py-5 flex justify-between items-center border-b border-slate-50 bg-slate-50/30">
          <div className="flex items-center gap-4">
            <h3 className="text-xl font-black text-slate-900 italic">
              רשומות שקילה
            </h3>
            <span
              key={records.length}
              id={records.length}
              className="px-3 py-1 bg-emerald-100 text-emerald-700 rounded-full text-[10px] font-black"
            >
              {records.length} רשומות נמצאו
            </span>
          </div>
        </div>

        <div className="overflow-x-auto max-h-[500px] overflow-y-auto">
          <table className="w-full text-center">
            <thead className="sticky top-0 z-20 bg-slate-50">
              <tr className="bg-slate-50/50 text-[10px] font-black text-grey-400 uppercase tracking-[2px]">
                <th
                  onClick={() => handleSort("id")}
                  className="px-2 py-3 cursor-pointer hover:text-slate-700"
                >
                  <span className="inline-flex items-center gap-1">
                    מזהה <SortArrow columnKey="id" />
                  </span>
                </th>
                <th
                  onClick={() => handleSort("site")}
                  className="px-2 py-3 cursor-pointer hover:text-slate-700"
                >
                  <span className="inline-flex items-center gap-1">
                    אתר <SortArrow columnKey="site" />
                  </span>
                </th>
                <th
                  onClick={() => handleSort("tag")}
                  className="px-2 py-3 cursor-pointer hover:text-slate-700"
                >
                  <span className="inline-flex items-center gap-1">
                    תג <SortArrow columnKey="tag" />
                  </span>
                </th>
                <th
                  onClick={() => handleSort("status")}
                  className="px-2 py-3 cursor-pointer hover:text-slate-700"
                >
                  <span className="inline-flex items-center gap-1">
                    סטטוס <SortArrow columnKey="status" />
                  </span>
                </th>

                <th
                  onClick={() => handleSort("weight")}
                  className="px-2 py-3 cursor-pointer hover:text-slate-700 whitespace-nowrap"
                >
                  <span className="inline-flex items-center gap-1">
                    משקל (KG) <SortArrow columnKey="weight" />
                  </span>
                </th>
                <th
                  onClick={() => handleSort("method")}
                  className="px-2 py-3 cursor-pointer hover:text-slate-700"
                >
                  <span className="inline-flex items-center gap-1">
                    שיטה <SortArrow columnKey="method" />
                  </span>
                </th>
                <th
                  onClick={() => handleSort("date")}
                  className="px-2 py-3 cursor-pointer hover:text-slate-700 whitespace-nowrap"
                >
                  <span className="inline-flex items-center gap-1">
                    תאריך ושעה <SortArrow columnKey="date" />
                  </span>
                </th>

                <th
                  onClick={() => handleSort("validation")}
                  className="px-2 py-3 cursor-pointer hover:text-slate-700"
                >
                  <span className="inline-flex items-center gap-1">
                    מאומתים <SortArrow columnKey="validation" />
                  </span>
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-50">
              {records.map((rec) => (
                <tr
                  key={rec.id}
                  className="hover:bg-slate-50/50 transition-colors group"
                >
                  <td className="px-2 py-3 font-mono text-sm font-bold text-slate-400">
                    {rec.id}
                  </td>
                  <td className="px-2 py-3 text-[12px] font-black text-slate-800 max-w-[170px] truncate">
                    {rec.site}
                  </td>
                  <td className="px-2 py-3 text-[12px] font-mono font-bold text-blue-600">
                    {rec.tag ? rec.tag : rec.status}
                  </td>
                  <td className="px-2 py-3">
                    <StatusPill status={rec.status} />
                  </td>
                  <td className="px-2 py-3 text-[12px] font-black text-slate-900">
                    {rec.weight}
                  </td>
                  <td className="px-2 py-3">
                    <span className="text-[10px] font-bold text-slate-500 px-3 py-1 bg-slate-100 rounded-lg">
                      {rec.method}
                    </span>
                  </td>
                  {/* <td className="px-2 py-3 text-center">
                    <div className="text-[11px] font-bold text-slate-800">
                      {rec.date}
                    </div>
                    <div className="text-[10px] font-bold text-slate-400">
                      {rec.time}
                    </div>
                  </td> */}
                  <td className="px-2 py-3 text-[11px] font-bold text-indigo-600">
                    {formatJerusalemDateTime(rec.date, rec.time)}
                  </td>
                  <td className="px-2 py-3 flex items-center justify-center">
                    {rec.validation === "Verified" ? (
                      <CheckCircle2 size={21} className="text-emerald-500" />
                    ) : (
                      <AlertCircle size={21} className="text-amber-500" />
                    )}
                    {/* <span className="text-xs font-bold">{rec.validation}</span> */}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

// Filter & Status Components
const FilterGroup = ({ label, icon, children }) => (
  <div className="flex flex-col gap-2">
    <div className="flex items-center gap-2 mr-1">
      <span className="text-slate-400">{icon}</span>
      <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest">
        {label}
      </label>
    </div>
    {children}
  </div>
);

const StatusPill = ({ status }) => {
  const styles = {
    manual: "bg-emerald-100 text-emerald-700",
    skipped: "bg-amber-100 text-amber-700",
    auto: "bg-slate-100 text-slate-500",
  };
  return (
    <span
      className={`px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-tighter ${styles[status]}`}
    >
      {status === "auto" ? "Auto" : status}
    </span>
  );
};

export default WeighingRecords;
